import Select2 from '../Select2/Select2';

export default {
    components: { Select2 },

    props: {
        disabled: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        optionsData: {
            type: Array,
        },
        placeholder: {
            type: String,
        },
        refreshFields: {
            type: Number,
        },
        required: {
            type: Boolean,
        },
        value: {
            default: null,
            type: [Array, Number, Object, String],
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    methods: {
        onChange({ id, value }) {
            this.$emit('change', {
                id,
                name: this.name,
                value,
            });
        },
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                this.$forceUpdate();
            }
        },
    },
};
